// Libraries
import React, { Component, Fragment } from "react";
import GoogleMapReact from "google-map-react";
import { toast } from "react-toastify";
import PropTypes from "prop-types";
import _ from "lodash";

// Config
import { mapStyle } from "../../../utils/scripts/map";

// Constants
const googleMapKey = process.env.REACT_APP_GOOGLE_MAP_KEY;

class TourMap extends Component {
  constructor() {
    super();
    this.handleGoogleMapApi = this.handleGoogleMapApi.bind(this);

    this.state = {
      google: undefined,
      directionsDisplay: undefined,
    };
  }

  static defaultProps = {
    center: {
      lat: 51.0504,
      lng: 13.7273,
    },
    zoom: 14,
  };

  componentDidUpdate(prevProps, prevState) {
    // console.log("prevstate", prevState);
    // console.log("state", this.state);
    // console.log("prevProps", prevProps);
    // console.log("props", this.props);

    // Initialization
    const equalObjects = _.isEqual(prevState.google, this.state.google);

    if (!equalObjects) {
      const { path } = this.props;

      if (path.length > 1) {
        this.handleDrawDirection();
      }
    }

    // When a Poi is being added or removed from the Path
    const equalArrayOfObjects = _(prevProps.path)
      .xorWith(this.props.path, _.isEqual)
      .isEmpty();

    if (this.state.google && !equalArrayOfObjects) {
      const { path } = this.props;

      if (path.length === 1) {
        this.handleMapReCenter();
      }

      if (path.length > 1) {
        this.handleDrawDirection();
      }
    }

    // When the order of a  Poi is being changed in the Path
    const equalOrderOfObjects =
      JSON.stringify(prevProps.path) === JSON.stringify(this.props.path)
        ? true
        : false;

    if (this.state.google && !equalOrderOfObjects) {
      const { path } = this.props;

      if (path.length > 1) {
        this.handleDrawDirection();
      }
    }
  }

  // Map initialization
  handleGoogleMapApi = (google) => {
    const directionsDisplay = new google.maps.DirectionsRenderer({
      suppressMarkers: false,
    });

    directionsDisplay.setOptions({
      polylineOptions: {
        strokeColor: "#337ab7",
        strokeOpacity: 1,
        strokeWeight: 3,
      },
      // draggable: true,
    });

    directionsDisplay.setMap(google.map);

    this.setState({ google: google, directionsDisplay: directionsDisplay });
  };

  // Recenter and Zoom
  handleMapReCenter = () => {
    const { google } = this.state;
    const { path } = this.props;

    // Get Map Center
    const count = path.length;
    let avg_lat = 0;
    let avg_long = 0;
    for (let i = 0; i < count; i++) {
      avg_lat += path[i].lat;
      avg_long += path[i].long;
    }

    // New center of Zoom chaning
    const center_lat = avg_lat / count;
    const center_long = avg_long / count;
    const laLatLng = new google.maps.LatLng(center_lat, center_long);

    // Amount of Zoom Changing
    const maxLat = Math.max.apply(
      Math,
      path.map(function (p) {
        return p.lat;
      })
    );
    const minLat = Math.min.apply(
      Math,
      path.map(function (p) {
        return p.lat;
      })
    );
    const maxLong = Math.max.apply(
      Math,
      path.map(function (p) {
        return p.long;
      })
    );
    const minLong = Math.min.apply(
      Math,
      path.map(function (p) {
        return p.long;
      })
    );
    const zoomFactor = (maxLat - minLat + maxLong - minLong) * 100;

    google.map.panTo(laLatLng);
    google.map.setZoom(16 - Math.round(zoomFactor));
  };

  // Draw Direction
  handleDrawDirection = () => {
    const { google, directionsDisplay } = this.state;
    const { path } = this.props;

    // Start
    const start = path[0];
    const origin = new google.maps.LatLng(start.lat, start.long);

    // Finish
    const finish = path[path.length - 1];
    const destination = new google.maps.LatLng(finish.lat, finish.long);

    // Stops
    const waypoints = [];
    if (path.length > 2) {
      const stops = path.slice(1, -1);
      for (let i = 0; i < stops.length; i++) {
        waypoints.push({
          location: new google.maps.LatLng(stops[i].lat, stops[i].long),
          stopover: true,
        });
      }
    }

    const directionsService = new google.maps.DirectionsService();
    directionsService.route(
      {
        origin: origin,
        waypoints: waypoints,
        destination: destination,
        // travelMode: google.maps.TravelMode.WALKING,
        travelMode: google.maps.DirectionsTravelMode.WALKING,
      },
      (response, status) => {
        if (status === google.maps.DirectionsStatus.OK) {
          directionsDisplay.setDirections(response);
        } else {
          // console.log(`error fetching directions ${response}`);
          toast.error(`Error fetching directions ${response}`);
        }
      }
    );
  };

  render() {
    function createMapOptions(maps) {
      return {
        zoomControlOptions: {
          position: maps.ControlPosition.LEFT_TOP,
          style: maps.ZoomControlStyle.SMALL,
        },
        mapTypeControlOptions: {
          position: maps.ControlPosition.TOP_RIGHT,
          style: maps.ZoomControlStyle.SMALL,
        },
        mapTypeControl: false,
        streetViewControl: true,
        styles: mapStyle,
        rotateControl: false,
        fullscreenControl: false,
        scrollwheel: true,
        disableDoubleClickZoom: true,
        draggableCursor: "grab",
        yesIWantToUseGoogleMapApiInternals: true,
      };
    }

    return (
      // Important! Always set the container height explicitly
      <Fragment>
        <p>Tour Map</p>
        <div style={this.props.style}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: googleMapKey,
            }}
            defaultCenter={this.props.center}
            defaultZoom={14}
            options={createMapOptions}
            yesIWantToUseGoogleMapApiInternals
            onGoogleApiLoaded={this.handleGoogleMapApi}
          ></GoogleMapReact>
        </div>
      </Fragment>
    );
  }
}

// Typechecking
TourMap.propTypes = {
  path: PropTypes.array.isRequired,
  style: PropTypes.object.isRequired,
};

export default TourMap;
